import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['dropDown']

  connect() {
    this.url = new URL(window.location)

    this.dropDownTargets.forEach(item => {
      item.addEventListener('blur', (event) => {
        item.classList.remove('h-open')
      });
    })
  }

  toggleDropdown(event) {
    const classList = event.currentTarget.classList
    if (classList.contains('h-open')){
      event.currentTarget.classList.remove('h-open')
    } else {
      event.currentTarget.classList.add('h-open')
    }
  }

  mediaTypeFilter(event) {
    this.url.searchParams.set('media_type', event.currentTarget.value)
    window.location.href = this.url.toString()
  }

  captionFilter(event) {
    this.url.searchParams.set('caption', event.currentTarget.value)
    window.location.href = this.url.toString()
  }

  langCodeFilter(event) {
    this.url.searchParams.set('lang_code', event.currentTarget.value)
    window.location.href = this.url.toString()
  }
}